import * as React from "react";
import styles from "./ResizableHorizPart.module.less";

type PropsResizableHorizPart = {
  children?: React.ReactNode;
  defaultWidth?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
};

/**
 * Компонент, позволяющий менять размер по горизонтали.
 * За счёт изменения правой границы.
 *                     ResizableHorizPart
 *                             ↓
 * ┌────────────────────┬────────────┐
 * │                    │            │
 * │                    ↔  children  │
 * │                    │            │
 * └────────────────────┴────────────┘
 */
export const ResizableHorizPart: React.FC<PropsResizableHorizPart> = (
  props,
) => {
  const {
    children,
    maxWidth = "50%",
    minWidth = "10%",
    defaultWidth = 200,
  } = props;
  const ref = React.useRef<HTMLDivElement>(null);
  const x0 = React.useRef(0);
  const [width, setWidth] = React.useState<number | string>(defaultWidth);
  const onDragStart: React.DragEventHandler = (e) => {
    x0.current = e.clientX + (ref.current?.clientWidth ?? 0);
  };
  const onDrag: React.DragEventHandler = (e) => {
    setWidth(x0.current - e.clientX);
  };
  return (
    <div ref={ref} className={styles.box} style={{ width, minWidth, maxWidth }}>
      <div
        className={styles.drag}
        draggable
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragEnd={onDrag}
      >
        <div className={styles.dragCenter} />
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};
